var v1="<div gnp-basic-analysis=\"\" basic-analysis-data=\"::rbCtrl.basicAnalysisData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-basic-chart/round-basic-chart.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/round-detail/round-basic-chart/round-basic-chart.jade
// module id = 574
// module chunks = 0